module.exports = __webpack_public_path__ + "img/icn-spec__controller--joyConGrip.d0815bc9.svg";